import React from 'react';
import { Checkbox } from 'antd';
import { MaterialReservation } from '../../../../../interfaces/MaterialInventory.interface';

interface MaterialChecklistProps {
    groupItem: MaterialReservation;
    checklistState: { [key: string]: boolean };
    handleChecklistCheckboxChange: (groupKey: string, field: string) => void;
}

const MaterialChecklist: React.FC<MaterialChecklistProps> = ({
    groupItem,
    checklistState,
    handleChecklistCheckboxChange,
}) => {
    const materialCertificateUrls = groupItem.material_length?.material?.material_certificate_urls;
    const groupKey = groupItem.group_key || 'no_group_key';

    return (
        <div key={groupKey} className="border p-4 mb-4">
            <p className="font-bold mb-4" style={{ fontSize: 16 }}>Material Acceptance Checklist</p>
            <div className="flex flex-col space-y-2">
                <Checkbox
                    className="block"
                    checked={checklistState[`${groupKey}_uniqueIdentifierMatches`]}
                    onChange={() => handleChecklistCheckboxChange(groupKey, 'uniqueIdentifierMatches')}
                >
                    Material’s Unique Identifier matches the record
                </Checkbox>
                <Checkbox
                    className="block"
                    checked={checklistState[`${groupKey}_sizeMatches`]}
                    onChange={() => handleChecklistCheckboxChange(groupKey, 'sizeMatches')}
                >
                    The material size matches the record
                </Checkbox>
                <Checkbox
                    className="block"
                    checked={checklistState[`${groupKey}_locationMatches`]}
                    onChange={() => handleChecklistCheckboxChange(groupKey, 'locationMatches')}
                >
                    The material location matches the record
                </Checkbox>
                <Checkbox
                    className="block"
                    checked={checklistState[`${groupKey}_otherMarkingsConsistent`]}
                    onChange={() => handleChecklistCheckboxChange(groupKey, 'otherMarkingsConsistent')}
                >
                    Other material markings (if applicable) are consistent with the record
                </Checkbox>
                <Checkbox
                    className="block"
                    checked={checklistState[`${groupKey}_appearanceTypeConsistent`]}
                    onChange={() => handleChecklistCheckboxChange(groupKey, 'appearanceTypeConsistent')}
                >
                    Material appearance and type is consistent with the record
                </Checkbox>
                <Checkbox
                    className="block"
                    checked={checklistState[`${groupKey}_conditionAcceptable`]}
                    onChange={() => handleChecklistCheckboxChange(groupKey, 'conditionAcceptable')}
                >
                    Material condition is acceptable for production
                </Checkbox>

                <Checkbox
                    className="block"
                    checked={checklistState[`${groupKey}_certificateMatches`]}
                    onChange={() => handleChecklistCheckboxChange(groupKey, 'certificateMatches')}
                >
                    Material certificate (if applicable) matches the record and material
                </Checkbox>
            </div>

            {materialCertificateUrls && materialCertificateUrls.length > 0 && (
                <div className="flex flex-col gap-1 ml-6 mt-4">
                    {materialCertificateUrls.map((url, certIndex) => (
                        <a
                            key={certIndex}
                            href={url}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="text-blue-600 hover:underline"
                        >
                            View/Download Certificate {certIndex + 1}
                        </a>
                    ))}
                </div>
            )}
        </div>
    );
};

export default MaterialChecklist;